module.exports = __webpack_public_path__ + "static/media/zgoda_na_zabieg_wybielania_zebow.dca8e01f.pdf";